/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Added_Detail_PlanInputs */

const en_us2_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today only. At the end of the workout you decide whether it goes into your plan.`)
};

const pt_br2_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje. No fim do treino você decide se entra no plano.`)
};

const es_419_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hoy. Al final del entrenamiento decides si pasa a tu plan.`)
};

const pt_pt2_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje. No fim do treino decides se entra no plano.`)
};

const fr_fr2_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui seulement. À la fin de la séance, tu décides s'il entre dans ton programme.`)
};

const de_de2_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur heute. Am Ende des Trainings entscheidest du, ob sie in deinen Plan kommt.`)
};

const it_it2_workout_added_detail_plan = /** @type {(inputs: Workout_Added_Detail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo oggi. A fine allenamento decidi se entra nella scheda.`)
};

/**
* | output |
* | --- |
* | "Today only. At the end of the workout you decide whether it goes into your plan." |
*
* @param {Workout_Added_Detail_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_added_detail_plan = /** @type {((inputs?: Workout_Added_Detail_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Added_Detail_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_added_detail_plan(inputs)
	if (locale === "es-419") return es_419_workout_added_detail_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_added_detail_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_added_detail_plan(inputs)
	if (locale === "de-DE") return de_de2_workout_added_detail_plan(inputs)
	if (locale === "it-IT") return it_it2_workout_added_detail_plan(inputs)
	return en_us2_workout_added_detail_plan(inputs)
});
export { workout_added_detail_plan as "workout.added_detail_plan" }